import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart, LineElement, CategoryScale, LinearScale, PointElement } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { formatThangTuoi } from '../../../../utils/tinhThangTuoiHelper';
import { getBMILabel } from '../ChieuCaoCanNangPage';

interface IBMIChartChartProps {
    dataSource: any[];
    grade: number;
}
Chart.register(LineElement, CategoryScale, LinearScale, PointElement);
Chart.register(ChartDataLabels);

const BMIChartChart = (props: IBMIChartChartProps) => {
    const { dataSource, grade } = props;
    const sortedData = [...dataSource].sort((a, b) => parseInt(a.so_thang, 10) - parseInt(b.so_thang, 10));

    const data = {
        labels: sortedData.map(x => formatThangTuoi(x.so_thang)),
        datasets: [
            {
                label: 'BMI',
                data: sortedData.map(x => x.bmi ?? 0),
                backgroundColor: sortedData.map(x => getBMILabel(x.bmi, grade).color),
                borderColor: sortedData.map(x => getBMILabel(x.bmi, grade).color),
                fill: false,
                tension: 0.4,
                barThickness: 25,
                maxBarThickness: 30,
            },
        ]
    };

    const options: any = {
        responsive: true,
        plugins: {
            legend: { position: 'bottom' as const, display: false },
            tooltip: { callbacks: { title: () => '', label: (context: any) => context.parsed.y } },
            title: { display: true, text: 'Biểu đồ BMI' },
            datalabels: { display: false },
        },
        scales: {
            x: { title: { display: true, text: 'Tuổi', font: { size: 13, weight: 'bold' } } },
            y: { title: { display: true, text: 'BMI', font: { size: 13, weight: 'bold' } }, beginAtZero: true },
        }
    };

    const legendItems = [
        { name: 'Sức khỏe dinh dưỡng tốt', color: '#1a7f37' },
        { name: 'Nguy cơ thừa cân', color: '#bf8700' },
        { name: 'Thiếu cân / Thừa cân', color: '#cf222e' }
    ];

    return <>
        <Bar data={data} options={options} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginTop: 10 }}>
            {legendItems.map((item, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ width: 12, height: 12, backgroundColor: item.color, display: 'inline-block', marginRight: 6, borderRadius: 2 }} />
                    <span style={{ fontSize: 13 }}>{item.name}</span>
                </div>
            ))}
        </div>
    </>;
};

export default BMIChartChart;
